<!-- 
	Loading
	props: N/A
  role: Public
	Simple loading spinner used across the application 
  Color can be defined in the style > border-color
-->

<template>
	<div class="loading">
		<div
			style="border-top-color: transparent"
			class="
        loading-wheel
        w-16
        h-16
        border-4 border-blue-400 border-dotted
        rounded-full
        animate-spin
        mx-auto
      "
		></div>
	</div>
</template>

<script>
	export default {
		name: "Loading",
	};
</script>
<style scoped>
	.loading-wheel {
		border-color: #e5d876;
	}
</style>
